var map = {
	"./aperitif-blue.svg": 1307,
	"./aperitif.svg": 4478,
	"./apero-blue.svg": 8432,
	"./apero.svg": 3195,
	"./arrow-blue.svg": 442,
	"./arrow-left.svg": 8218,
	"./arrow-right.svg": 3518,
	"./arrow-up.svg": 5372,
	"./arrow.svg": 6791,
	"./cadeau-blue.svg": 9520,
	"./cadeau.svg": 4341,
	"./check.svg": 1122,
	"./cheese-blue.svg": 815,
	"./cheese.svg": 4119,
	"./convivial.svg": 8096,
	"./dessert-blue.svg": 7569,
	"./dessert.svg": 8841,
	"./empty.svg": 5394,
	"./en amoureux.svg": 9420,
	"./fermer.svg": 1431,
	"./fish-blue.svg": 9033,
	"./fish.svg": 8987,
	"./fresh-blue.svg": 9925,
	"./fresh.svg": 1708,
	"./fruity-blue.svg": 7494,
	"./fruity.svg": 3468,
	"./full.svg": 5610,
	"./glass.svg": 9368,
	"./grapes.svg": 1180,
	"./meat-blue.svg": 4510,
	"./meat.svg": 4042,
	"./neutral.svg": 3993,
	"./occasion-blue.svg": 43,
	"./occasion.svg": 2240,
	"./pin.svg": 7016,
	"./plat.svg": 3989,
	"./reload-white.svg": 7438,
	"./reload.svg": 7492,
	"./round-blue.svg": 1667,
	"./round.svg": 6488,
	"./scrolldown.svg": 6906,
	"./share.svg": 7259,
	"./shopping-list.svg": 1762,
	"./spicy-blue.svg": 7133,
	"./spicy.svg": 3786,
	"./store-finder.svg": 7764,
	"./surprise-blue.svg": 777,
	"./surprise.svg": 4938,
	"./valider.svg": 2172,
	"./vege-blue.svg": 2343,
	"./vege.svg": 5329,
	"./vin-blanc.svg": 3702,
	"./vin-bulles.svg": 495,
	"./vin-rose.svg": 2499,
	"./vin-rouge.svg": 7146,
	"./vin-vide.svg": 6136
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3331;